const getPaymentMethodName = require('./getPaymentMethodName');
const getPaymentMethodTitle = require('./getPaymentMethodTitle');
const addStatuses = require('../utils/addStatuses');
const statuses = require('./statuses');

class Payment {

  constructor(payment){
    Object.assign(this, payment);
    this.method_name = getPaymentMethodName(this.method);
    this.method_title = getPaymentMethodTitle(this.method);
  }

  isCredit(){
    return this.method_name === 'credit';
  }

  isOnline(){
    return this.method_name === 'online';
  }

  isSuccess(){
    return this.debit_success;
  }
}

addStatuses.run(Payment.prototype, statuses);

module.exports = data => new Payment(data);